import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import style from './TrackSelector.css';
import { buildAssetUrl } from '../../helpers';

const defaultAvatarURL = 'assets/images/logos/_a_transparent.svg';

const VisToggle = ({ visible = true, toggleVisibility }) => (
  <div
    className={style.visToggle}
    onClick={e => {
      toggleVisibility();
      e.stopPropagation();
    }}
  >
    <svg width='24' height='24' fill='none' stroke='#FFF' strokeWidth='2'>
      <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' />
      <circle cx='12' cy='12' r='3' />
      {visible ? null : <line x1='0' y1='24' x2='24' y2='0' />}
    </svg>
  </div>
);

class TrackSelector extends Component {
  componentWillMount() {
    this.setState({ filter: false });
  }
  filter() {
    if (!this.state.filter) return this.props.tracks;
    return this.props.tracks.filter(t => {
      if (!t.avatar || !t.avatar.name) return false;
      return t.avatar.name.toLowerCase().includes(this.state.filter.toLowerCase());
    });
  }
  handleClickOutside() {
    this.props.closeMenu();
  }
  render() {
    return (
      <div className={style.selectorWrapper}>
        <input
          type='text'
          className={style.filter}
          placeholder='Filter'
          onChange={evt => {
            this.setState({ filter: evt.target.value });
          }}
        />
        <ul className={style.list}>
          {this.filter().map(track => (
            <li
              key={track.activityId}
              onClick={() => {
                if (!track.show) return;
                this.props.setTarget(track.activityId);
                this.props.closeMenu();
              }}
              className={`${style.track} ${track.show ? '' : style.hidden} ${track.active ? style.active : ''}`}
            >
              <img
                style={{ backgroundColor: track.color }}
                src={track.avatar.image || buildAssetUrl(defaultAvatarURL)}
                className={style.img}
                alt='Avatar name'
              />
              <span>{track.avatar.name} </span>
              <VisToggle
                visible={track.show}
                toggleVisibility={() => {
                  this.props.toggleVisibility(track.activityId);
                  if (track.active) {
                    const newTarget = this.props.tracks.find(t => t.show && t !== track);
                    if (newTarget) this.props.setTarget(newTarget.activityId);
                  }
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export const TrackSelectorButton = ({ count, setModal, hideElements }) => {
  if (count <= 1 || hideElements.includes('trackSelector')) {
    return null;
  }
  return (
    <a onClick={() => setModal('TrackSelector')} className={style.TrackSelectorButton} data-numtracks={count}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='23' viewBox='0 0 20 23'>
        <g fill='none' fillRule='evenodd' transform='translate(-10 -8)'>
          <rect width='40' height='40' />
          <g stroke='white' strokeWidth='2' transform='translate(11 9)'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M0,8 C0,8 0,8.76160653e-16 9,0 C18,0 18,8 18,8'
              transform='translate(0 13)'
            />
            <circle cx='9' cy='4.5' r='4.5' />
          </g>
        </g>
      </svg>
    </a>
  );
};

export default onClickOutside(TrackSelector);
